<!-- Common header-->

<app-header extraClass="text-gray nav-down" standardProduct=true displayNavigation=true></app-header>

<!-- Top Banners -->
<app-banner-top></app-banner-top>

<div class="middle-panel hidelg">
  <ul uk-tab class="swtitch-tab">
    <li><a [routerLink]="['/'+this.appService.getCurrentCity().toLowerCase()+'/exclusives']">Exclusive</a></li>
    <li class="uk-active"><a
      [routerLink]="['/'+this.appService.getCurrentCity().toLowerCase()+'/deals']">Deals</a>
    </li>
  </ul>
</div>

<!--Categories Slider--->
<app-categories></app-categories>

<!--POPULAR EXPERIENCE-->
<app-popular-experiences></app-popular-experiences>

<!--DISCOUNT SLIDER-->
<app-discount-slider apiPath="middle"></app-discount-slider>

<!--LOVED BRANDS--->
<app-most-loved-brands></app-most-loved-brands>

<!--TRENDING--->
<app-trending-products apiPath="top" categoryName="Food and Drinks"></app-trending-products>

<!--NEW ARRIVED--->
<app-new-arrivals></app-new-arrivals>

<!--DISCOUNT SLIDER-->
<app-discount-slider apiPath="bottom"></app-discount-slider>

<!--TRENDING--->
<app-trending-products apiPath="bottom" categoryName="Staycation"></app-trending-products>
<app-footer></app-footer>
